module.exports = __webpack_public_path__ + "static/media/workflow_image1.c2ff61d1.webp";